import { useEffect, useRef, useState } from 'react'
import useCrashStore from '../store/useCrashStore'

/**
 * useCrashBettingTimer — локальный тикер таймера приёма ставок.
 *
 * bettingDeadlineAt — абсолютный дедлайн, вычисляется один раз в onRound от bettingMs.
 * Тикает локально, чтобы не зависеть от сетевых задержек. На нуле ставки уже НЕ принимаются,
 * даже если crash:run ещё не пришёл (§3: «таймер истёк → блокируй кнопку, а не жди события»).
 */
export const useCrashBettingTimer = () => {
  const bettingDeadlineAt = useCrashStore((s) => s.bettingDeadlineAt)
  const phase = useCrashStore((s) => s.phase)
  const [remainingMs, setRemainingMs] = useState(0)
  const timerRef = useRef(null)

  useEffect(() => {
    if (phase !== 'betting' || !bettingDeadlineAt) {
      setRemainingMs(0)
      return
    }

    const tick = () => {
      const remaining = Math.max(0, bettingDeadlineAt - Date.now())
      setRemainingMs(remaining)
      if (remaining <= 0) {
        if (timerRef.current) {
          clearInterval(timerRef.current)
          timerRef.current = null
        }
      }
    }
    tick()
    timerRef.current = setInterval(tick, 100)

    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current)
        timerRef.current = null
      }
    }
  }, [phase, bettingDeadlineAt])

  // Секунды для отображения (ceil, чтобы не показывать 0.0 раньше времени)
  const remainingSec = Math.ceil(remainingMs / 1000)
  const isExpired = remainingMs <= 0

  return { remainingMs, remainingSec, isExpired }
}

export default useCrashBettingTimer
